import React from 'react';

const NavOverlay = ({ onClick }) => {
  return <div className="sidebar-overlay" onClick={onClick} />;
};

export default NavOverlay;
